import { initializePendo } from 'utils/pendo';
import { initializeWebTracking } from '@hqo/web-tracking';
import { setUser as setSentryUser } from '@sentry/react';
import { useEffect } from 'react';
import { usePendoAnalytics } from 'hooks/use-pendo-analytics.hook';
import { useWebTrackingAnalytics } from 'hooks/use-web-tracking.hook';

export const useAnalytics = (): void => {
  const analytics = usePendoAnalytics();
  const webTrackingData = useWebTrackingAnalytics();

  useEffect(() => {
    if (window.pendo && analytics) {
      initializePendo(window.pendo, analytics);
    }
    setSentryUser(analytics);
  }, [analytics]);

  useEffect(() => {
    if (webTrackingData?.token && webTrackingData?.buildingUuid && webTrackingData.apiUrl) {
      initializeWebTracking(
        webTrackingData?.token,
        webTrackingData?.buildingUuid,
        webTrackingData?.appUuid,
        navigator?.userAgent,
        webTrackingData?.apiUrl,
      );
    }
  }, [webTrackingData?.appUuid, webTrackingData?.buildingUuid, webTrackingData?.token, webTrackingData?.apiUrl]);
};
